import React from 'react';
import { object } from 'prop-types';

import classes from './PanelInsert.module.css';

const CampusPanelInsert = ({ node }) => {
    return (
        <dl className={classes.agentInfo}>
            <dt>Name</dt>
            <dd>{node.name}</dd>
        </dl>
    );
};

CampusPanelInsert.defaultProps = {
    node: {}
};

CampusPanelInsert.propTypes = {
    node: object.isRequired
};

export default CampusPanelInsert;
